import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import GlobalButton from "../../common/GlobalButton";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function Procedures() {
  // State to control modal open/close
  const [open, setOpen] = useState(false);

  return (
    <Box>
      {/* Button to open the modal */}
      <Tooltip title="Download Procedures" arrow>
        <GlobalButton
          onClick={() => setOpen(true)}
          sx={{
            minWidth: 80,
            height: 36,
            px: 2,
            py: 0.5,
          }}
        >
          Procedures Files
        </GlobalButton>
      </Tooltip>

      {/* Modal Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <iframe
            height="500px"
            width="100%"
            frameborder="0"
            allowTransparency="true"
            scrolling="auto"
            src="https://creatorapp.zohopublic.com/sst1source/source-erp/report-embed/All_Procedures/kZM5YbVkD5SevwM8Ua7t8Vm97CE1tKSfr6RAG2QA6zZ7t38xa0Vf3FEZtvrehsr9V8ugq6uFr9jDNBUY9nRuraC1mzeMUazFjgV4"
          ></iframe>
        </DialogContent>
        <DialogActions>
          {/* Close button */}
          <GlobalButton
            size="small"
            variant="contained"
            onClick={() => setOpen(false)}
            icon={<RestartAltIcon />}
            sx={{ minWidth: 80, height: 36, px: 2, py: 0.5 }}
          >
            RESET
          </GlobalButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
